import { render, staticRenderFns } from "./tdSurveyNameLink.vue?vue&type=template&id=57d2d6d3&scoped=true"
import script from "./tdSurveyNameLink.vue?vue&type=script&lang=js"
export * from "./tdSurveyNameLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2d6d3",
  null
  
)

export default component.exports